(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const text = JSON.parse(root.querySelector('[data-mkal-text]').textContent);
    const status = root.querySelector('[data-mkal-status]');
    const format = value => new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Berlin' }).format(new Date(value));
    if (root.dataset.source === 'shopify') {
      root.querySelectorAll('[data-mkal-release]').forEach(time => {
        const release = Date.parse(time.dataset.mkalRelease);
        if (Number.isFinite(release)) time.textContent = format(release);
      });
      return;
    }
    function safeUrl(value) {
      if (!value) return null;
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /^\/apps\/mkal\/(download|watch)\//.test(url.pathname) ? url.href : null;
    }
    function render(data) {
      if (!Array.isArray(data.weeks) || data.weeks.length !== 8 || data.weeks.some((w,i) => w.week !== i+1 || typeof w.available !== 'boolean')) throw new Error('Invalid schedule');
      root.dispatchEvent(new CustomEvent('mkal:schedule',{detail:data}));
      const count = data.weeks.filter(w => w.available).length;
      status.textContent = `${count} ${text.count}`;
      if(data.nextUnlockAt) status.textContent += ` · ${text.next} ${format(data.nextUnlockAt)}`;
      root.querySelector('[data-mkal-progress]').value = count;
      for (const week of data.weeks) {
        const card = root.querySelector(`[data-week="${week.week}"]`);
        card.dataset.state = week.available ? 'available' : 'locked';
        card.querySelector('[data-label]').textContent = week.available ? text.available : text.locked;
        card.querySelector('[data-description]').textContent = week.available ? (week.title || text.part) : (week.unlockAt ? `${text.next} ${format(week.unlockAt)}` : text.wait);
        const actions = card.querySelector('[data-actions]');
        actions.replaceChildren();
        if (!week.available) continue;
        for(const [kind,label] of [['pdf',text.pdf],['video',text.video]]) {
          const href = safeUrl(week[kind]);
          if(!href) continue;
          const a = document.createElement('a');
          a.href = href; a.textContent = label;
          a.className = `mkal-button${kind==='video'?' secondary':''}`;
          actions.append(a);
        }
        if(!actions.children.length) { const p = document.createElement('p'); p.textContent = text.missing; actions.append(p); }
      }
    }
    if (root.dataset.connected !== 'true') {
      const calendar=['2026-10-03T06:20:00+02:00','2026-10-10T08:00:00+02:00','2026-10-17T08:00:00+02:00','2026-10-24T08:00:00+02:00','2026-10-31T08:00:00+01:00','2026-11-07T08:00:00+01:00','2026-11-14T08:00:00+01:00','2026-11-21T08:00:00+01:00'];
      root.querySelectorAll('[data-week]').forEach(card=>{ card.querySelector('[data-description]').textContent=`${text.next} ${format(calendar[Number(card.dataset.week)-1])}`; });
      return;
    }
    status.hidden = false;
    status.textContent = text.loading;
    fetch(`/apps/mkal/access?project=${encodeURIComponent(root.dataset.project)}`, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)})
      .then(async response => {
        if(response.status === 401) { status.textContent = text.login; root.querySelector('[data-mkal-login]').hidden=false; return; }
        if(response.status === 403) { status.textContent = text.no_access; return; }
        if(!response.ok) throw new Error('Access unavailable');
        render(await response.json());
      }).catch(() => { status.textContent = text.error; });
  }
  document.querySelectorAll('[data-mkal]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mkal]').forEach(init));
})();
